export const ORDER_STATUS_MAP = {
  1: {
    key: "CREATED",
    label: { en: "Created", ar: "تم الإنشاء" },
  },
  2: {
    key: "PREPARED",
    label: { en: "Prepared", ar: "تم التحضير" },
  },
  3: {
    key: "ON_DELIVERY",
    label: { en: "On Delivery", ar: "قيد التوصيل" },
  },
  4: {
    key: "DELIVERED",
    label: { en: "Delivered", ar: "تم التوصيل" },
  },
  5: {
    key: "COMPLETED",
    label: { en: "Completed", ar: "مكتمل" },
  },
  6: {
    key: "CANCELLED",
    label: { en: "Cancelled", ar: "ملغي" },
  },
};
